import { z } from 'zod'

/** 日期 Schema */
export const dateValueSchema = z.union([
  z.string().regex(/^$/),
  // YYYY/MM/DD
  z.string().regex(/(\d{4}\/(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01]))/),
  // YYYY/MM/DD HH:mm:ss
  z
    .string()
    .regex(
      /^\d{4}\/(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\s([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/
    )
])

/** 日期 */
export type DateValue = z.infer<typeof dateValueSchema>
